import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { EditoHotelListItem } from 'app/typings/core/admin/hotels/editoHotelList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useEditoHotels() {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.editoHotels],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getEditosHotels,
      }) as Promise<EditoHotelListItem[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
